// @ts-nocheck
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { BLUE } from '../../_config/consts';
import * as PowerControlUnitsActions from '../../redux/actions/powerControlUnits.actions';
import * as ModalActions from '../../redux/actions/modal.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import PowerControlUnitDetailsView from './PowerControlUnitDetailsView.jsx';

const theme = createTheme({
  palette: {
    primary: { 500: BLUE },
  },
});

@connect(state => ({
  form: state.form.PowerControlUnitDetailsForm,
  selectedPCU: state.powerControlUnits.selectedPCU,
}))
class PowerControlUnitsOperationalSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async onSave(pcuData) {
    const { dispatch, selectedPCU, onPCUEditConfirmed, onPCUCreateConfirmed } = this.props;
    
    const isEdit = selectedPCU && selectedPCU.id;
    
    dispatch(UtilsActions.setSpinnerVisibile(true));
    
    try {
      let result;
      if (isEdit) {
        result = await dispatch(PowerControlUnitsActions.editPowerControlUnit(selectedPCU.id, pcuData));
        if (onPCUEditConfirmed) {
          onPCUEditConfirmed(result);
        }
      } else {
        result = await dispatch(PowerControlUnitsActions.createPowerControlUnit(pcuData));
        if (onPCUCreateConfirmed) {
          onPCUCreateConfirmed(result);
        }
      }
      
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="pcuSaveSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="pcuSaveError" /></h6>),
        },
      }));
    }
  }

  render() {
    const { formStyle } = this.props;

    return (
      <MuiThemeProvider theme={theme}>
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          <div style={{ flex: 1, overflow: 'auto' }}>
            <PowerControlUnitDetailsView
              formStyle={formStyle}
              onSubmit={(pcuData) => this.onSave(pcuData)}
            />
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default PowerControlUnitsOperationalSection;
